module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "list"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_02_img#page_ii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frontispiece")]), _vm._v(", Ernst Haeckel and Nikolai Miklucho")]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_09_ch1#fig1.1"
    }
  }, [_vm._v("1.1. Embryos from two stages of development, from Moore’s "), _c('em', [_vm._v("Before We Are Born")]), _vm._v(" (1989)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_09_ch1#fig1.2"
    }
  }, [_vm._v("1.2. Isadora Duncan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_09_ch1#fig2.1"
    }
  }, [_vm._v("2.1. Ernst Haeckel with his parents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_10_ch2#fig2.2"
    }
  }, [_vm._v("2.2. Alexander von Humboldt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_10_ch2#fig2.3"
    }
  }, [_vm._v("2.3. Frontispiece of Matthias Schleiden’s "), _c('em', [_vm._v("Die Pflanze und ihr Leben")]), _vm._v(" (1848)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_10_ch2#fig2.4"
    }
  }, [_vm._v("2.4. Members of the medical faculty at Würzburg")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_10_ch2#fig2.5"
    }
  }, [_vm._v("2.5. Johann Wolfgang von Goethe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_10_ch2#fig2.6"
    }
  }, [_vm._v("2.6. Johannes Peter Müller")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_10_ch2#fig2.7"
    }
  }, [_vm._v("2.7. Ernst Haeckel in 1858")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_10_ch2#fig2.8"
    }
  }, [_vm._v("2.8. Anna Sethe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_11_ch3#fig3.1"
    }
  }, [_vm._v("3.1. Hermann Allmers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_11_ch3#fig3.2"
    }
  }, [_vm._v("3.2. Ernst Haeckel in 1860")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_11_ch3#fig3.3"
    }
  }, [_vm._v("3.3. Micrographs of radiolarians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_11_ch3#fig3.4"
    }
  }, [_vm._v("3.4. "), _c('em', [_vm._v("Heliosphaera,")]), _vm._v(" from Haeckel’s "), _c('em', [_vm._v("Die Radiolarien")]), _vm._v(" (1862)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_11_ch3#fig3.5"
    }
  }, [_vm._v("3.5. HMS "), _c('em', [_vm._v("Challenger")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_12_ch4#fig4.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1. Main university building of Friedrich-Schiller-Universtät")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_12_ch4#fig4.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2. Carl Gegenbaur")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_12_ch4#fig4.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.3. Charles Darwin in 1860")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_12_ch4#fig4.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.4. Rudolf Virchow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_12_ch4#fig4.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.5. Anna Sethe Haeckel and Ernst Haeckel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_12_ch4#fig4.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.6. "), _c('em', [_vm._v("Mitrocoma Annae,")]), _vm._v(" from Haeckel’s "), _c('em', [_vm._v("System der Medusen")]), _vm._v(" (1879)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#fig5.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.1. Ernst Haeckel and companions on trip to Helgoland, 1865")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#fig5.2",
      "id": "page_xii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.2. Life cycle of a medusa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#fig5.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.3. Stem-tree of plants, protists, and animals, from Haeckel’s "), _c('em', [_vm._v("Generelle Morphologie der Organismen")]), _vm._v(" (1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#fig5.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.4. Stem-tree of lineal progenitors of man, from Haeckel’s "), _c('em', [_vm._v("Anthropogenie")]), _vm._v(" (1874)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#fig5.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.5. Karl Ernst von Baer, about age eighty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#fig5.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.6. Nauplius")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#fig5.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.7. Bronn’s tree of systematic relationships")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#fig5.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.8. Tree of Indo-German languages, from August Schleicher’s "), _c('em', [_vm._v("Darwinsche Theorie und die Sprachwissenschaft")]), _vm._v(" (1863)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#fig5.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.9. Schleicher’s scheme for illustrating morphology and descent of languages")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#fig5.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.10. Stem-tree of the vertebrates, from Haeckel’s "), _c('em', [_vm._v("Generelle Morphologie der Organismen")]), _vm._v(" (1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#fig6.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1. Charles Darwin in 1874")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#fig6.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.2. Nikolai Miklucho")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#fig6.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.3. Freshwater hydra, from Haeckel’s "), _c('em', [_vm._v("Arbeitsteilung in Natur und Menschenleben")]), _vm._v(" (1868, 1910)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#fig6.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.4. Hydrozoan colony, from Haeckel’s "), _c('em', [_vm._v("Arbeitsteilung in Natur und Menschenleben")]), _vm._v(" (1868, 1910)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#fig6.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.5. Siphonophore, from Haeckel’s "), _c('em', [_vm._v("Arbeitsteilung in Natur und Menschenleben")]), _vm._v(" (1868, 1910)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#fig6.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.6. Experiments on siphonophore larvae, from Haeckel’s "), _c('em', [_vm._v("Zur Entwickelungsgeschichte der Siphonophoren")]), _vm._v(" (1869)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#fig6.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.7. Calcareous sponge, from Haeckel’s "), _c('em', [_vm._v("Die Kalkschwämme")]), _vm._v(" (1872)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#fig6.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.8. "), _c('em', [_vm._v("Guancha blanca,")]), _vm._v(" from Miklucho’s “Beiträge zur Kenntniss der Spongien I” (1868)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#fig6.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.9. Cell cleavage and formation of the blastula, from Haeckel’s “Die Gastrula und die Eifurchung der Thiere” (1875)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#fig6.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.10. Gastrula of several phyla of animals, from Haeckel’s “Die Gastraea-Theorie” (1874)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#fig6.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.11. "), _c('em', [_vm._v("Ascetta primordialis,")]), _vm._v(" from Haeckel’s "), _c('em', [_vm._v("Die Kalkschwämme")]), _vm._v(" (1872)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#fig6.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.12. Letter from Haeckel to Darwin (1873)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.1. Agnes Haeckel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.2. Ernst Haeckel in 1868")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.3. Frontispiece of Haeckel’s "), _c('em', [_vm._v("Natürliche Schöfungsgeschichte")]), _vm._v(" (1868)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.4. Twelve human species, from Haeckel’s "), _c('em', [_vm._v("Natürliche Schöpfungsgeschichte")]), _vm._v(" (1870)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.5",
      "id": "page_xiii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.5. Haeckel’s illustration of the biogenetic law (1868)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.6. Dog embryo, from Bischoff’s "), _c('em', [_vm._v("Entwicklungsgeschichte des Hunde-Eies")]), _vm._v(" (1845)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.7. Human embryo, from Ecker’s "), _c('em', [_vm._v("Icones physiologicae")]), _vm._v(" (1851–59)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.8. Human embryo, from Kölliker’s "), _c('em', [_vm._v("Entwicklungsgeschichte des Menschen und der höheren Thiere")]), _vm._v(" (1861)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.9. Human embryos, from Ecker’s "), _c('em', [_vm._v("Icones physiologicae")]), _vm._v(" (1851–59) and Haeckel’s "), _c('em', [_vm._v("Natürliche Schöpfungsgeschichte")]), _vm._v(" (1868)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.10. Illustration of the biogenetic law, from Haeckel’s "), _c('em', [_vm._v("Anthropogenie")]), _vm._v(" (1874)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.11. Eggs of human, ape, and dog, from Haeckel’s "), _c('em', [_vm._v("Natürliche Schöpfungsgeschichte")]), _vm._v(" (1868)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.12. Sandal embryos, from Haeckel’s "), _c('em', [_vm._v("Natürliche Schöpfungsgeschichte")]), _vm._v(" (1868)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.13. Stem-tree of the human species, from Haeckel’s "), _c('em', [_vm._v("Natürliche Schöpfungsgeschichte")]), _vm._v(" (1868)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.14. Stem-tree of the human species, from Haeckel’s "), _c('em', [_vm._v("Natürliche Schöpfungsgeschichte")]), _vm._v(" (1870–79)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.15. Stem-tree of the human species, from Haeckel’s "), _c('em', [_vm._v("Natürliche Schöpfungsgeschichte")]), _vm._v(" (1889–1920)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.16. Map of human dispersal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#fig7.17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.17. "), _c('em', [_vm._v("Pithecanthropus alalus,")]), _vm._v(" ape-man without speech")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.1. Wilhelm His")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.2. Human sandal embryo, from Haeckel’s "), _c('em', [_vm._v("Anthropogenie")]), _vm._v(" (1874)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.3. Human sandal embryo with primitive streak, from Graf von Spee’s “Beobachtungen an einer menschlichen Keimscheibe” (1889)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.4. Human sandal embryo with primitive streak, from Haeckel’s A"), _c('em', [_vm._v("nthropogenie")]), _vm._v(" (1903)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.5. Human embryo with allantois, from Haeckel’s "), _c('em', [_vm._v("Anthropogenie")]), _vm._v(" (1874)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.6. Alexander Goette")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.7. Albert von Kölliker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.8. Richardson’s embryos compared with Haeckel’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.9. Altered photos of Richardson’s embryos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.10. Normal table of embryos, from His’s "), _c('em', [_vm._v("Anatomie menschlicher Embryonen")]), _vm._v(" (1880–85)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.11. Emil Du Bois-Reymond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.12. Carl Nägeli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.13. Rudolf Virchow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.14",
      "id": "page_xiv",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.14. Hôtel de Ville, Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.15. Barricades and cannons on a Paris street")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.16. Illustration of the biogenetic law, from Haeckel’s "), _c('em', [_vm._v("Anthropogenie")]), _vm._v(" (1903)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.17. Echidna embryos, from Semon’s "), _c('em', [_vm._v("Zoologische Forschungsreisen")]), _vm._v(" (1893–)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.18. Illustration of embryonic similarity of human and dog, from Darwin’s "), _c('em', [_vm._v("Descent of Man")]), _vm._v(" (1871)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig8.19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.19. Illustration of von Baer’s law that organisms develop from a general to a more specific morphology during ontogeny, from Gilbert’s "), _c('em', [_vm._v("Developmental Biology")]), _vm._v(" (1985–97)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#fig9.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.1. Ernst Haeckel on the way to Ceylon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#fig9.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.2. Haeckel’s house, Villa Medusa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#fig9.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.3. Market square in Jena")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#fig9.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.4. Erich Wasmann as seminarian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#fig9.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.5. Two species of the “guests of ants”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#fig9.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.6. Father Erich Wasmann, S.J.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#fig9.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.7. Meeting of the Monistenbund")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#fig9.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.8. Eberhard Dennert")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#fig9.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.9. Embryos illustrating the biogenetic law, from Haeckel’s "), _c('em', [_vm._v("Das Menschen-Problem")]), _vm._v(" (1907)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#fig9.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.10. Ape embryos at comparable stages, from Selenka’s "), _c('em', [_vm._v("Menschenaffen")]), _vm._v(" (1903) and Haeckel’s "), _c('em', [_vm._v("Menschen-Problem")]), _vm._v(" (1907)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#fig9.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.11. Human embryos at comparable stages, from His’s "), _c('em', [_vm._v("Anatomie menschlicher Embryonen")]), _vm._v(" (1880–85) and Haeckel’s "), _c('em', [_vm._v("Menschen-Problem")]), _vm._v(" (1907)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#fig9.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.12. Comparison of ape skeletons with the human skeleton, from Haeckel’s "), _c('em', [_vm._v("Menschen-Problem")]), _vm._v(" (1907)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#fig9.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.13. John Wendell Bailey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.1. Frida von Uslar-Gleichen and Bernhard von Uslar-Gleichen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.2. Agnes Haeckel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.3. René Binet’s Porte Monumentale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.4. Discomedusa "), _c('em', [_vm._v("Rhopilema Frida")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.5. Hamburg German-American liner "), _c('em', [_vm._v("Kiautschou")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.6. Haeckel’s letter to Frida")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.7. Frida von Uslar-Gleichen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.8. Haeckel’s illustration of the “Apotheosis of Evolutionary Thought”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.9",
      "id": "page_xv",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.9. Isadora Duncan with Haeckel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.10. Phyletic Museum, Jena")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.11. Else Meyer, Ernst Haeckel, and Walter Haeckel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.12. French trenches at Verdun")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.13. German postcard with “Argonnerwald-Lied”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.14. Haeckel in his study, 1914")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#fig10.15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.15. Haeckel’s grave marker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#app1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("App. 1.1. Johann Wolfgang von Goethe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#app1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("App. 1.2. Karl Friedrich Burdach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#app1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("App. 1.3. Lorenz Oken")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#app1.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("App. 1.4. Friedrich Tiedemann")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#app1.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("App. 1.5. Carl Gustav Carus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#app1.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("App. 1.6. Vertebrate archetype, from Carus’s "), _c('em', [_vm._v("Von den Ur-theilen des Knochenund Schalengerüstes")]), _vm._v(" (1828)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#app1.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("App. 1.7. Ideal vertebra, from Carus’s "), _c('em', [_vm._v("Von den Ur-theilen des Knochen- und Schalengerüstes")]), _vm._v(" (1828)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#app1.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("App. 1.8. Heinrich Georg Bronn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#app1.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("App. 1.9. Karl Ernst von Baer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#app1.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("App. 1.10. Richard Owen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#app1.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("App. 1.11. Vertebrate archetype, from Owen’s "), _c('em', [_vm._v("On the Nature of Limbs")]), _vm._v(" (1849)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#app1.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("App. 1.12. Vertebrate limbs of mole and bat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#app1.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("App. 1.13. Charles Darwin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_21_app2#app2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("App. 2.1. Plaque in the main university building at Jena")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tablet"
  }, [_c('em', [_vm._v("Plates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/plates#plate1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 1. Radiolaria of the subfamily Eucyrtidium, from Haeckel’s "), _c('em', [_vm._v("Radiolarien")]), _vm._v(" (1862)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/plates#plate2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 2. Alexander von Humboldt and Aimé Bonpland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/plates#plate3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 3. Haeckel’s portrait of the "), _c('em', [_vm._v("Nationalversammlung der Vögel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/plates#plate4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 4. Haeckel’s watercolor of his study on Capri")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/plates#plate5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 5 Discomedusa "), _c('em', [_vm._v("Desmonema Annasethe,")]), _vm._v(" from Haeckel’s "), _c('em', [_vm._v("System der Medusen")]), _vm._v(" (1879)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/plates#plate6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 6. "), _c('em', [_vm._v("Physophora magnifica,")]), _vm._v(" from Haeckel’s "), _c('em', [_vm._v("Zur Entwickelungsgeschichte der Siphonophoren")]), _vm._v(" (1869)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/plates#plate7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 7. Scene from Haeckel’s "), _c('em', [_vm._v("Arabische Korallen")]), _vm._v(" (1876)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/plates#plate8",
      "id": "page_xvi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 8. Haeckel’s landscape of the highlands of Java")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2beca2db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226712192_07_ill.vue
// module id = 72
// module chunks = 0